/**
 * Web-arcade analytics — client-only, SSR-safe.
 *
 * When we import the AWSConstants and AWSManager from @sdk-mobile, sometimes
 * it starts parsing the @sdk-mobile import during SSR and that throws an exception
 * since @sdk-mobile should only be loaded from client side. This module imports
 * lazily only when an event actually fires on the client. So statically
 * importing this helper from an SSR'd component is safe.
 */

export const ARCADE_EVENT = {
  TILE_CLICKED: 'web_arcade_tile_clicked',
  LOBBY_VIEW: 'web_arcade_lobby_view',
  RETURN_CLICKED: 'web_arcade_return_clicked',
} as const;

type ArcadeEvent = (typeof ARCADE_EVENT)[keyof typeof ARCADE_EVENT];

export function trackArcadeEvent(
  event: ArcadeEvent,
  params: Record<string, string | number> = {}
): void {
  // Never run during SSR.
  if (typeof window === 'undefined') return;

  import('@/sdk-mobile-web/AWSManager/AWSManager.web')
    .then(({default: AWSManager}) => {
      AWSManager.trackEvent(event as Parameters<typeof AWSManager.trackEvent>[0], params);
    })
    .catch((err) => {
      console.error(
        '[web_arcade] trackArcadeEvent failed',
        JSON.stringify({event, err: String(err)})
      );
    });
}
